import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

const tileMotion = (index, reducedMotion) => reducedMotion ? { scale: 1, x: 0, y: 0 } : {
  scale: [1, 1.055],
  x: [0, index % 2 === 0 ? -7 : 7],
  y: [0, index < 2 ? -4 : 4],
};

export const PracticeCollageBanner = ({ photos }) => {
  const reducedMotion = useReducedMotion();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (reducedMotion || photos.length < 2) return undefined;
    const timer = window.setInterval(() => setActiveIndex((index) => (index + 1) % photos.length), 6500);
    return () => window.clearInterval(timer);
  }, [photos.length, reducedMotion]);

  return (
    <header className="relative w-full aspect-[4/5] sm:aspect-[4/3] lg:aspect-[16/6] overflow-hidden bg-[#0a1f44]" data-testid="practice-times-collage-banner" data-reduced-motion={reducedMotion ? 'true' : 'false'} aria-label="Ian ICE Cotterell animated photo collage">
      <div className="absolute inset-0 grid grid-cols-2 lg:grid-cols-4" data-testid="practice-times-collage">
        {[0, 1, 2, 3].map((tileIndex) => {
          const photo = photos.length ? photos[(activeIndex + tileIndex) % photos.length] : null;
          return <div key={tileIndex} className="relative overflow-hidden bg-[#0a1f44]" data-testid={`practice-collage-tile-${tileIndex + 1}`}>
            {photo && <AnimatePresence initial={false} mode="sync">
              <motion.div key={`${photo.id}-${activeIndex}-${tileIndex}`} className="absolute inset-0 will-change-transform" initial={reducedMotion ? false : { opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: reducedMotion ? 0 : 1.4, ease: 'easeInOut' }}>
                <motion.div className="absolute -inset-3" animate={tileMotion(tileIndex, reducedMotion)} transition={{ duration: 7, ease: 'linear' }}>
                  <img src={photo.url} alt={photo.caption} className={`w-full h-full ${photo.rotation ? 'object-contain' : 'object-cover'}`} style={photo.rotation ? { transform: `rotate(${photo.rotation}deg) scale(0.72)` } : undefined} loading="eager" decoding="async" data-testid={`practice-collage-photo-${tileIndex + 1}-${photo.id}`} />
                </motion.div>
              </motion.div>
            </AnimatePresence>}
          </div>;
        })}
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent pointer-events-none" aria-hidden="true" />
      <motion.div className="absolute left-0 right-0 bottom-0 z-10 px-6 sm:px-10 lg:px-16 pb-8 sm:pb-10 lg:pb-12 text-white pointer-events-none" data-testid="practice-collage-name-overlay" initial={reducedMotion ? false : { opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: reducedMotion ? 0 : 0.8, ease: 'easeOut' }}>
        <div className="w-14 h-1 bg-[#c8102e] mb-4" />
        <div className="font-heading uppercase tracking-[0.3em] text-xs sm:text-sm" data-testid="practice-collage-ian-name">Ian Cotterell</div>
        <div className="font-display text-5xl sm:text-6xl leading-none mt-1" data-testid="practice-collage-ice-name">“ICE”</div>
      </motion.div>
    </header>
  );
};